import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { TRosterUserPeerSupportCertificateInfo } from '@/types/Roster.types';
import { upgradeMemberToPeerSupportPost } from '@/services/api/requests/peer-support';

const useUpgradeMemberToPeerSupport = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({
      organizationId,
      userId,
      peerSupportUpgradeInfo,
    }: {
      organizationId: string;
      userId: string;
      peerSupportUpgradeInfo: TRosterUserPeerSupportCertificateInfo;
    }) => {
      const response = await upgradeMemberToPeerSupportPost(organizationId, userId, peerSupportUpgradeInfo);

      return response;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Successfully upgraded Member to Peer Support!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          status: 'error',
          title: 'Error',
          description: error.errors[0].message ?? 'Error while upgrading Member to Peer Support',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default useUpgradeMemberToPeerSupport;
